import {Injectable} from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {

  constructor() { }

  setItem(itemKey: string, itemValue: any): void {
    localStorage.setItem(itemKey, JSON.stringify(itemValue));
  }

  getItem(itemKey: string): any {
    return JSON.parse(localStorage.getItem(itemKey));
  }
}
